import { css } from '@emotion/react'

import type { Breakpoints } from './breakpoints'
import { breakpoint } from './breakpoints'

export const hiddenDown = (hiddenDown: Breakpoints) => css`
  ${breakpoint.down(hiddenDown)} {
    display: none !important;
  }
`
export const hiddenUp = (hiddenUp: Breakpoints) => css`
  ${breakpoint.up(hiddenUp)} {
    display: none !important;
  }
`
